export default __webpack_public_path__ + "static/media/Group2022.5469da57.png";